import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { catchError, concatMap, mergeMap, of, tap, withLatestFrom } from "rxjs";
import { QuoteClient } from "src/api-service";
import { normalizeError } from "../../../app-store-error.types";
import { selectSelectedCompany } from "../../../user/user.selectors";
import { QuoteCreateActions } from "./quote-create.actions";

@Injectable()
export class QuoteCreateEffects {

    private readonly actions$ = inject(Actions);
    private readonly store = inject(Store);
    private readonly quoteClient = inject(QuoteClient);
    private readonly router = inject(Router);

    // =========================================================================
    // CREATE QUOTE
    // =========================================================================

    createQuote$ = createEffect(() =>
        this.actions$.pipe(
            ofType(QuoteCreateActions.create),
            withLatestFrom(this.store.select(selectSelectedCompany)),
            concatMap(([{ request }, selectedCompany]) =>
                this.quoteClient.create(request, selectedCompany.id).pipe(
                    mergeMap(quote => [
                        QuoteCreateActions.createSuccess({
                            newQuoteId: quote.id,
                            companyId: selectedCompany.id,
                            toastKey: 'QUOTE.TOAST.CREATE_SUCCESS'
                        })
                    ]),
                    catchError(error => of(QuoteCreateActions.createFailure({
                        error: normalizeError(error),
                        toastKey: 'QUOTE.TOAST.CREATE_ERROR'
                    }))),
                ),
            ),
        ),
    );

    // =========================================================================
    // NAVIGATION - Redirect after success
    // =========================================================================

    navigateToQuote$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(QuoteCreateActions.createSuccess),
                tap(({ newQuoteId, companyId }) => {
                    this.router.navigate([companyId, "quote", newQuoteId]);
                }),
            ),
        { dispatch: false },
    );
}
